import V from 'voUtils/V.js';
import DateEx from 'voUtils/DateEx.js';


import {
	isBlank,
	doReq
}
from 'voUtils/RestEx.js';

import {
	findResultFields
}
from 'voUtils/BrowserEx.js';

export default {
	data: function () {
		return {
			units: [],
			imagesForModal: [],
			from: undefined,
			till: undefined,
		};
	},
	// props: {
	// 	filter: Object,
	// 	sorting: String,
	// 	max: String
	// },
	beforeMount: function () {
		var results = this.$el.getElementsByClassName('unit-list-section');
		if (results.length) {
			this.resultFields = findResultFields(results[0].innerHTML, this.$el);
		}

		var req = {

			/* fields: this.resultFields, */

			fields: {
				"u.path": {
					"field": "path",
					"filter": "vlang"
				},
				"u.images": {
					"field": "images"
				},
				"u._id": {
					"field": "_id"
				},
				"u.idxImage": {
					"field": "idxImage"
				},
				"u.name": {
					"field": "name",
					"filter": "vautolang"
				},
				"u.calc.discountName": {
					"field": "calc.discountName"
				},
				"u.pricelist": {
					"field": "pricelist"
				},
				"u.in+units": {
					"field": "in+units"
				},
				"u.beachdistance": {
					"field": "beachdistance",
					"filter": "vautokm"
				},
				"u.squareMeters": {
					"field": "squareMeters"
				},
				"u.bedrooms": {
					"field": "bedrooms"
				},
				"u.rooms": {
					"field": "rooms"
				},
				"u.bathrooms": {
					"field": "bathrooms"
				},
				"u.wifi": {
					"field": "wifi"
				},
				"u.pets": {
					"field": "pets"
				},
				"u.nonsmoking": {
					"field": "nonsmoking"
				},
				"u.balcony": {
					"field": "balcony"
				},
				"u.p_15518": {
					"field": "p_15518"
				},
				"u.privateparking": {
					"field": "privateparking"
				},
				"u.stars": {
					"field": "stars"
				},
				"u.feedback": {
					"field": "feedback"
				},

				"u.alternatives": {
					"field": "alternatives"
				},
				"u.calc": {
					"field": "calc"
				},
				"u.calc.oTotal": {
					"field": "calc.oTotal",
					"filter": "vcurrency"
				},
				"u.minRent": {
					"field": "minRent",
					"filter": "vcurrency"
				},
				"u.offers": {
					"field": "offers"
				},
				"u.regionName": {
					"field": "regionName",
					"filter": "vlang"
				},
				"u.facilityName": {
					"field": "facilityName",
					"filter": "vautolang"
				},
				"u.type": {
					"field": "type",
					"filter": "vsoption",
					"filterparams": [
						"hpunit.type"
					]
				},
				"u.calc.total": {
					"field": "calc.total",
					"filter": "vcurrency"
				},
				"u.loc.coordinates": {
					"field": "loc.coordinates"
				},
				"u.address.street": {
					"field": "address.street"
				},
				"u.address.city": {
					"field": "address.city"
				}
			},

			filter: {
				from: this.getFrom(),
				till: this.getTill(),
				nights_min: 3,
				nights_max: 5,
			},
			max: 6,
			sorting: 'random',
			alternatives: true,
			fuzzy: true
		};

		doReq('searchUnits', req)
			.then((res) => {
				this.units = res.units;
			});

		console.log("req::", req);
	},

	updated: function () {
		this.applySlider();
		$('[data-toggle="tooltip"]').tooltip();
		$('[data-toggle="popover"]').popover();
	},
	methods: {
		getSearchUrl: function () {
			var url = './s#?from=' + this.from + '&till=' + this.till + '&nights_min=2&nights_max=7';
			return url;
		},
		getUnitSearchPath: function (path, o) {

			var searchKeys = ['from', 'till', 'adults', 'children', 'babys', 'pets', 'petsCount'];
			var params = [];
			for (let sp of searchKeys) {
				if (o && o[sp]) {
					params.push(sp + '=' + o[sp]);
				}
			}

			if (params.length) {
				path += '#?' + params.join('&');
			}
			return path;


		},
		getAlternatePeriod: function (u) {
			var result = null;
			if (u.matchingPeriods && u.matchingPeriods.length > 0) {
				result = {
					from: u.matchingPeriods[0].fromdate,
					till: u.matchingPeriods[0].tilldate
				};
				return result;
			}
			if (u.alternatives && u.alternatives.length > 0) {
				result = {
					from: u.alternatives[0].fromdate,
					till: u.alternatives[0].tilldate
				};
				return result;
			}
			return result;
		},

		getTill: function () {
			var today = DateEx.interfaceFormat(DateEx.getToday());
			var till = DateEx.interfaceFormat(DateEx.plusDays(today, 23));
			console.log('till:::', till);
			this.till = till;
			return till;


		},
		getFrom: function () {
			var today = DateEx.interfaceFormat(DateEx.getToday());
			var from = DateEx.interfaceFormat(DateEx.plusDays(today, 2));
			console.log('from:::', from);
			this.from = from;
			return from;

		},
		getUnitSearchTarget: function (id) {
			if (window.screen.width < 768) {
				//probably phone?
				return '_self';
			} else {
				return 'unit_' + id;
			}
		},
		handleResize: function () {
			this.applySlider();

		},
		showImagesModal: function (images, uniqueId = '') {
			if (images && images.length > 1) {
				this.imagesForModal = images;
				//$('#unitImages').modal('show');
				this.showCustomModal('unitImages' + uniqueId);

			} else {
				this.imagesForModal = [];
			}
		},
		showCustomModal: function (id) {
			let wh = window.innerHeight;

			// Get the modal
			const modal = document.getElementById(id);

			if (modal) {
				var dialog = modal.getElementsByClassName("modal-custom-dialog")[0];
				var content = modal.getElementsByClassName("modal-custom-content")[0];
				var body = document.body;

				if (dialog && content) {
					dialog.style.height = wh - 40 + "px";
					content.style.height = wh - 120 + "px";

					modal.style.display = "block";
					body.classList.add('modal-open');


					// When the user clicks anywhere outside of the modal, close it
					window.onclick = function (event) {
						if (event.target == modal) {
							modal.style.display = "none";
							body.classList.remove('modal-open');
						}
					};
				}
			}
		},

		closeCustomModal: function (id) {
			const modal = document.getElementById(id);
			var body = document.body;
			if (modal) {
				modal.style.display = "none";
				body.classList.remove('modal-open');
			}

		},


		applySlider: function () {
			console.log('applying slider.........');
			//var windowWidth = window.innerWidth;

			$(".owl-carousel.lastminuteunits").owlCarousel({
				loop: false,
				margin: VOFFICE.settings.olwCarouselMargin,
				smartSpeed: 1000,
				autoplay: false,
				nav: true,
				dots: true,
				responsive: {
					0: {
						items: 1
					},
					768: {
						items: 2
					},
					996: {
						items: 3
					},
					1200: {
						items: 3

					}
				}
			});

		}
	}

};